import { c as _c } from "react/compiler-runtime";
import type { ChartConfig } from '@/components/ui/chart';
import type { ComponentProps } from 'react';
import type { AiAttributionSegment } from './ai-attribution-segments';
import { ChartLegendStatic } from '@/components/ui/chart';
import { BetterTooltip } from '@/components/ui/tooltip';
type AiAttributionBreakdownBarProps = {
  segments: AiAttributionSegment[];
  legendConfig: ChartConfig;
  legendPayload: NonNullable<ComponentProps<typeof ChartLegendStatic>['payload']>;
};
export function AiAttributionBreakdownBar(t0) {
  const $ = _c(10);
  const {
    segments,
    legendConfig,
    legendPayload
  } = t0;
  let t1;
  if ($[0] !== legendConfig || $[1] !== legendPayload) {
    t1 = <div data-testid="pr-v2-ai-code-legend" className="py-0.5"><ChartLegendStatic config={legendConfig} payload={legendPayload} verticalAlign="top" className="justify-start gap-x-3 gap-y-1 pb-0 pt-0 text-[11px]" /></div>;
    $[0] = legendConfig;
    $[1] = legendPayload;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== segments) {
    t2 = segments.map(_temp);
    $[3] = segments;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div data-testid="pr-v2-ai-code-breakdown-bar" className="flex h-2 overflow-hidden rounded-full bg-zinc-900/80 ring-1 ring-white/5 ring-inset">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <BetterTooltip side="top" align="start" content={t1}>{t3}</BetterTooltip>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(segment) {
  return <div key={segment.key} data-testid={`pr-v2-ai-code-segment-${segment.key}`} className={segment.barClassName} style={{
    width: `${segment.widthPercent}%`
  }} />;
}